<template>
  <card>
    <list
      v-if="$store.state.user.sections['statuses']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "season",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "name",
          label: "Название",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "code",
          label: "code",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_status",
      itemLink: "statuses",
      setLink: "statuses",
      columns: [
        {
          key: "id",
          title: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "name",
          title: "Название",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "code",
          title: "Ключ",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          //remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
